<template>
  <div>
    <div class="modal fade" id="updateWorkStatusModal" ref="updateWorkStatusModal" tabindex="-1" aria-labelledby="Изменить" aria-hidden="true">
      <div  class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div  class="modal-content p-3">
          <div class="modal-header d-flex mb-20 border-0 p-1">
						<span v-if="is_loaded" class="modal-title d-flex me-auto fs-2 fw-semi font-semi lh-1 me-auto w-90">
							Смена статуса объекта
						</span>
            <button type="button" class="d-flex ms-auto btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <template v-if="is_loaded">
            <InputSelect  inputId="work_status_select"
                          inputName="work_status_select"
                          :inputValue="this.selected_work_status_id"
                          :inputOptions="this.filteredWorkStatusList"
                          inputClass="rounded-1 p-2"
                          inputWrapClass="flex-column"
                          @setValue="(value) => selected_work_status_id = value" />
          </template>
          <Loader v-else />
          <div v-if="is_loaded" class="modal-footer border-0 p-1">
            <button type="button"
                    class="btn btn-primary col-12 rounded-3 py-3 text-white fs-3"
                    :disabled="!this.object_id"
                    @click="saveWorkStatus()" >
              Сохранить
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import CommonService from "@/services/CommonService";
import Loader from '@/components/common/Loader.vue';
import InputSelect from "@/components/inputs/InputSelect";


export default {
	name: 'updateWorkStatusModal',
	components: { Loader, InputSelect },
  data() {
    return {
      object_id: null,
      selected_work_status_id: null,
      is_loaded: false,
      work_status_list: [
        { id: 1, name: 'Черновик (в рекламу не выгружен!)' },
        { id: 2, name: 'На проверке (в рекламу не выгружен!)' },
        { id: 3, name: 'Проверен' }
      ]
    };
  },

  methods: {
    isEmpty(data) {
      return CommonService.isEmpty(data);
    },
    inArray(needle, haystack) {
      return CommonService.inArray(needle, haystack);
    },

    saveWorkStatus() {
      if (!this.object_id || !this.selected_work_status_id) return;

      const data = {
        object_id: this.object_id,
        work_status: this.selected_work_status_id
      };

      api.put('/object/setWorkStatus', data)
          .then(response => {
            if (response.status === 200 && response.data.success) {
              this.$emit('updateObject', this.object_id);

              const modal = CommonService.getModal('updateWorkStatusModal');
              if (modal) modal.hide();
            }
          })
          .catch(error => {
            console.error('Ошибка установки статуса:', error);
          });
    },

    icon(path, class_name, title, size) {
      return CommonService.buildIconImage(path, class_name, title, size);
    },
  },
	mounted() {
    const modal = this.$refs.updateWorkStatusModal;

    if (modal && typeof modal !== "undefined") {

      modal.addEventListener('hidden.bs.modal', () => {
        this.object_id = null;
        this.selected_work_status_id = null;
        this.emitter.emit("global.modalClose", modal);
      });

      modal.addEventListener('show.bs.modal', (event) => {
        let target = event.relatedTarget;

        this.object_id = target.getAttribute('data-bs-object-id') || null;
        const statusId = target.getAttribute('data-bs-status-id');
        this.selected_work_status_id = statusId ? parseInt(statusId, 10) : null;

        console.log('selected_work_status_id:', this.selected_work_status_id);
        console.log('typeof selected_work_status_id:', typeof this.selected_work_status_id);

        this.is_loaded = true;
        this.emitter.emit("global.modalShown", modal);
      });
		}
	},
  computed: {
    filteredWorkStatusList() {
      const canSeeChecked = this.$store.getters.userInfo.is_agency ||
          this.$store.getters.userInfo.is_users_admin ||
          this.$store.getters.userInfo.permissions.menu_check_work_status == 1;

      const list = this.work_status_list
          .filter(item => {
            if (item.id === 3 && !canSeeChecked) {
              return false;
            }
            return true;
          })
          .map(item => ({
            value: item.id,
            name: item.name
          }));

      // Убираем "Не выбрано"
      return list.filter(item => item.value !== 0);
    }
  }
}
</script>